import { ActionType } from "typesafe-actions";

import { Deeplink, Platform } from "../common_types";

import * as actions from "./actions";

export type ClicksAction = ActionType<typeof actions>;

export interface ClickItem {
  createdAt: string;
  platform: Platform;
  marker: string;
  isUnique: boolean;
  proposalPrice: number;
  gatePriceAmount: number;
  gatePriceCurrency: string;
  referrerHost: string;
  deeplink: Deeplink;
  searchUserIp: string;
  origin0: string;
  destination0: string;
  origin1: string;
  destination1: string;
  prediction: number | undefined;
  market: string | undefined;
  mainAirline: string;
  isMixedFlights: boolean;
}

export enum ClicksActionTypes {
  TABLE_FETCH_REQUEST = "@Clicks/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Clicks/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Clicks/TABLE_FETCH_ERROR",

  RETRIEVE_FETCH_REQUEST = "@Clicks/RETRIEVE_FETCH_REQUEST",
  RETRIEVE_FETCH_SUCCESS = "@Clicks/RETRIEVE_FETCH_SUCCESS",
  RETRIEVE_FETCH_ERROR = "@Clicks/RETRIEVE_FETCH_ERROR",

  GENERATE_REPORT_REQUEST = "@Clicks/GENERATE_REPORT_REQUEST",
}

export interface ClicksState {
  readonly count: number;
  readonly isLoading: boolean;
  readonly tableData: ClickItem[];
  readonly retrieveIsLoading: boolean;
  readonly retrieve?: ClickItem;
}
